import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppMessageState {
  open: boolean;
  title: string;
  message: string;
  type: "success" | "error" | "info";
}

const initialState: AppMessageState = {
  open: false,
  title: "",
  message: "",
  type: "info",
};

const appMessageSlice = createSlice({
  name: "appMessage",
  initialState,
  reducers: {
    showMessage: (
      state,
      action: PayloadAction<{
        title: string;
        message: string;
        type?: "success" | "error" | "info";
      }>,
    ) => {
      state.open = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.type = action.payload.type || "info";
    },
    hideMessage: (state) => {
      state.open = false;
    },
  },
});

export const { showMessage, hideMessage } = appMessageSlice.actions;
export default appMessageSlice.reducer;
